// extracted by mini-css-extract-plugin
export default {"logoContainer":"W7HDHM6EFe9JuGldFl66","logo":"EJq0onOMmGdqIUIfc8tz","heading":"OTDqf0ySDcM5wZf4F_8E","timeTurns":"IPs8AahnHkMd8vdN5Aex"};